import React from 'react'

const PaginationBtn = ({ icon, action }:{icon: React.ReactNode, action: () => void}) => {
  return (
    <div className='pagination-btn' onClick={action}>
      {icon}
    </div>
  )
}

export default PaginationBtn